var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddClientIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.541C26 20.7502 24.2091 22.541 22 22.541C19.7909 22.541 18 20.7502 18 18.541C18 16.3319 19.7909 14.541 22 14.541C24.2091 14.541 26 16.3319 26 18.541Z",
    stroke: "#00424B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.541C30.2091 22.541 32 20.7502 32 18.541C32 16.3319 30.2091 14.541 28 14.541",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.541H20C17.2386 25.541 15 27.7796 15 30.541C15 31.6456 15.8954 32.541 17 32.541H27C28.1046 32.541 29 31.6456 29 30.541C29 27.7796 26.7614 25.541 24 25.541Z",
    stroke: "#00424B",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.541C32.7614 25.541 35 27.7796 35 30.541C35 31.6456 34.1046 32.541 33 32.541H31.5",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClientIcon);
export default __webpack_public_path__ + "static/media/add-client-icon.6ca2bcaadbd6177b6634826b68c2d2a2.svg";
export { ForwardRef as ReactComponent };